<template>
  <svg
    class="icon"
    :width="icon_width"
    :height="icon_height"
    :viewBox="viewBox"
    role="img"
    aria-hidden="true"
  >
    <use :href="iconPath" :xlink:href="iconPath" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  icon: { type: String, required: true },
  icon_width: { type: [String, Number], default: 24 },
  icon_height: { type: [String, Number], default: 24 },
  viewBox: { type: String, default: '0 0 24 24' }
});

const iconPath = computed(() =>
  new URL('@/assets/sprites/sprite.svg', import.meta.url).href + '#' + props.icon
);
</script>

<style scoped>
.icon { 
  display: inline-block; 
  vertical-align: middle; 
  --icon-color: #8A8F9C;
  color: var(--icon-color);
  fill: var(--icon-color);
}
</style>
